// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ScheduleHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ScheduleContainer component
 */
/**
 */
import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash/fp';
import ReportNameEditor from 'modules/ReportDesigner/Izenda.ReportNameEditor';
import connect from 'share/enhancers/Izenda.Connect';

const ScheduleContainer = (props: any) => {
  const {
    store: { reportStore }
  } = props;
  const {
    model: { reportName }
  } = reportStore;
  return isNil(reportName) ? null : (
    <div className='u_paddingRight'>
      <ReportNameEditor store={reportStore} name={reportName} showTooltip={false} isPreviewRecord={false} />
    </div>
  );
};

ScheduleContainer.propTypes = {
  store: PropTypes.object.isRequired
};

export default connect()(ScheduleContainer);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Schedule/Izenda.ScheduleHeader.jsx